
const api = {
	getFileList: '/fileDownloadTask/listFileDownloadTasks',  // evh 获取文件列表
	cancelJob: '/fileDownloadTask/cancelTask',							 // evh 取消导出(针对正在导出的文件)
	updateDownloadTimes: '/fileDownloadTask/updateFileDownloadTimes', // evh 更新下载次数
};

const routes = {
	'/file-center': '导出中心'
};

export {
	api,
	routes
};
